export default __webpack_public_path__ + "static/media/window-contact.8ded12ec.jpg";